import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const HowAddNewAlbum: React.FC = () => {
  return <div id={"HowAddNewAlbum"}>
    <h2>
      Как добавить новый альбом
    </h2>
    <p>
      Авторизуйтесь в личном кабинете по адресу partner.um-agency.com и нажмите на
      кнопку <b>Новый релиз</b> в левом верхнем углу.
    </p>
    <div className={"text-center"}>
      <img className={"max-h-[350px]"} src={"/help/add_album.jpg"} alt={"Добавить новый альбом"} />
    </div>
    <p>
      <br />
      Заполните все обязательные поля в открывшемся окне. Обязательные поля отмечены красной звёздочкой.<br /> Наведите
      курсор на значок <FontAwesomeIcon size={"lg"} className={"text-gray-500"} icon={faCircleInfo} /> ,чтобы увидеть
      больше информации о каждом поле.
      <br /><br />
      После внесения основной информации о продукте сохраните изменения и загрузите обложку. Обратите внимание на
      некоторые нюансы при заполнении основной информации:
    </p>
    <ul className={"list-disc"}>
      <li>
        Поля <b>Дата релиза</b> и <b>Оригинальная дата релиза</b> не влияют на дату доступности альбома на площадках.
      </li>
      <li>
        Данные из поля <b>Дата релиза</b> будут отображаться в плейлисте альбома на площадках. Также эти данные
        используются для ранжирования альбомов в карточках музыкантов
      </li>
      <li>
        Вы можете указать <b>Оригинальную дату релиза</b>, если делаете перевыпуск альбома
      </li>
      <li>
        Оба типа даты не обязательны к заполнению
      </li>
      <li>
        В поле <b>Жанр</b> можно выбрать от одного до трёх жанров
      </li>
      <li>
        Код <b>External ID</b> является обязательным и сгенерируется системой автоматически, даже если вы его не
        укажете. Все остальные сервисные коды вводятся вручную
      </li>
      <li>
        В качестве обложки альбома рекомендуется использовать квадратные изображения в формате .jpg, .jpeg, .png
        размером не менее 1500px.
      </li>
    </ul>
  </div>;
};
